import {
  DeleteDocumentTemplateDocument,
  DeleteDocumentTemplateMutation,
  DeleteDocumentTemplateMutationVariables,
  GetDocumentTemplatesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useDeleteDocumentTemplate = () => {
  const [deleteMutation, { loading }] = useMutation(DeleteDocumentTemplateDocument, {
    extractorFn: (data: DeleteDocumentTemplateMutation) =>
      data.documentsMutations.deleteDocumentsTemplate,
  })

  return {
    loading,
    deleteDocumentTemplate(variables: DeleteDocumentTemplateMutationVariables) {
      return deleteMutation({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GetDocumentTemplatesDocument,
          },
        ],
      })
    },
  }
}

export default useDeleteDocumentTemplate
